import {Input, Label} from "reactstrap";
import {t} from "i18next";
import AgeConsent from "../../common/AgeConsent";
import ElementWithAccessInCountries from "lib/utils/hocs/ElementWithAccessInCountries";
import {useMetrikaRgsInsuredScreen} from "../../../lib/utils/hooks/useMetrikaRgsInsuredScreen";

//@ts-ignore
const MemberCheckboxes = ({isInsuredBefore, dataContainer, peopleAmount, register, errors, values}) => {
    const isDataPeopleRequired = dataContainer?.slot?.confirm_participant_data;
    const dataPeopleRequired = isDataPeopleRequired && peopleAmount > 1;
    const dataPeopleNotRequired = !isDataPeopleRequired && peopleAmount > 1;

    useMetrikaRgsInsuredScreen(isInsuredBefore);

    return <>
        {dataPeopleRequired &&
                <div className="checkout__input-wrapper radio-input">
                    <Input
                        type="checkbox"
                        id="verificationData"
                        name="verificationData"
                        error={errors.verificationData}
                        innerRef={register({
                            required: true,
                        })}
                    />
                    <Label htmlFor="verificationData">{t('sport.membersScreen.fillOthers')}</Label>

                    <div className={`note-label ${errors.verificationData ? 'note-label--error' : ''}`}>
                        {dataContainer?.slot?.participant_data_info || t('sport.membersScreen.participantDataRequired')}
                    </div>
                </div>
        }
        {dataPeopleNotRequired &&
            <div className="checkout__input-wrapper radio-input">
                <Input
                    type="checkbox"
                    defaultChecked
                    id="duplicateData"
                    name="duplicateData"
                    innerRef={register()}
                />
                <Label htmlFor="duplicateData">{t('sport.membersScreen.dontFillOthers')}</Label>
            </div>
        }
        {dataContainer?.slot?.check_age_required &&
                <AgeConsent register={register} error={errors.ageConsent} value={values.ageConsent} required
                            age={dataContainer?.slot?.check_age_value}/>
        }
        {isInsuredBefore &&
                    <ElementWithAccessInCountries hideInCountries={['EN']}>
                        <div className="checkout__input-wrapper radio-input">
                            <Input
                                    type="checkbox"
                                    id="is_insured"
                                    name="is_insured"
                                    innerRef={register()}
                                    error={errors.insuranceConsent}
                            />
                            <Label htmlFor="is_insured">{t('sport.membersCheckboxes.insured')}</Label>
                        </div>
                    </ElementWithAccessInCountries>
        }
    </>
}

export default MemberCheckboxes